declare namespace $ {

	export class $shm_hitalama_map_widget_tools_link_pick extends $mol_pick {
		Input( ): $mol_view
	}
	
}

//# sourceMappingURL=pick.view.tree.d.ts.map